import {
  ASTRONOMICAL_BUFF,
  GodiverseBuff,
  GodiverseLite
} from '@apeiron/godiverse'
import { MayNull } from '@apeiron/temp'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const useGodiverseBuff = (): Hook => {
  const { t } = useTranslation()

  const getBuffConfig = useCallback(
    (astronomical: MayNull<GodiverseLite>): GodiverseBuff => {
      if (astronomical && astronomical.agingBuff > 0) {
        return {
          color: {
            buffName: ASTRONOMICAL_BUFF.COLOR.AGING.BUFF_NAME,
            buff: ASTRONOMICAL_BUFF.COLOR.AGING.BUFF
          },
          value: {
            buffName: t('astronomical.buff.aging'),
            buff: astronomical.agingBuff
          }
        }
      }

      if (astronomical && astronomical.orbitTrack > 0) {
        return {
          color: {
            buffName: ASTRONOMICAL_BUFF.COLOR.ORBITAL_TRACK.BUFF_NAME,
            buff: ASTRONOMICAL_BUFF.COLOR.ORBITAL_TRACK.BUFF
          },
          value: {
            buffName: t('astronomical.buff.orbital_track'),
            buff: astronomical.orbitTrack
          }
        }
      }

      return {
        color: {
          buffName: 'white',
          buff: 'white'
        },
        value: {
          buffName: '',
          buff: 0
        }
      }
    },
    [t]
  )

  return {
    getBuffConfig
  }
}

type Hook = {
  getBuffConfig: (astronomical: MayNull<GodiverseLite>) => GodiverseBuff
}

export default useGodiverseBuff
